export function isOlderThanMinutes(tsSeconds: number, minutes = 60): boolean {
  if (!tsSeconds || typeof tsSeconds !== 'number') return true;  
  const tsMs = tsSeconds * 1000;  
  const diffMs = Date.now() - tsMs;
  return diffMs > minutes * 60_000;
}

export function formatTimestampToTime(tsSeconds: number): string {
  if (!tsSeconds || typeof tsSeconds !== 'number') return '-';
  
  const date = new Date(tsSeconds * 1000); // converte para ms
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${hours}:${minutes}`;
}